import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
export const CheckPath = styled.path `
  fill: ${({ theme, variant: $variant }) => theme.check[$variant]};
  ${({ checked }) => !checked &&
    css `
      display: none;
    `}
`;
export function BKJCheck(props) {
    const { variant, checked, disabled } = props;
    return (_jsx("svg", { width: 12, height: 10, fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx(CheckPath, { fillRule: "evenodd", clipRule: "evenodd", d: "M10.594 0l1.47 1.356L4.906 9.12 0 3.837l1.466-1.361 3.435 3.7L10.594 0z", variant: variant, disabled: disabled, checked: checked }) }));
}
//# sourceMappingURL=BKJCheck.js.map